import { Navigate, useLocation, useParams } from 'react-router-dom'
import { blissShortLinkDestination } from '../utils/blissShortLinks'

/**
 * Resolves the short proposal links we put in text messages and plain-text
 * email (`/p/<code>`) into the full approval URL.
 */
export default function ProposalShortLink() {
  const { code } = useParams<{ code: string }>()
  const { search } = useLocation()
  const destination = code ? blissShortLinkDestination(code) : null

  if (!destination) {
    return <Navigate to="/" replace />
  }

  const extraParams = search.replace(/^\?/, '')
  const to = extraParams
    ? `${destination}${destination.includes('?') ? '&' : '?'}${extraParams}`
    : destination

  return <Navigate to={to} replace />
}
